export enum IncomeReportDateType {
  exDate = 'exDate',
  payDate = 'payDate'
}
